module.exports = __webpack_public_path__ + "static/img/lead.2c205772.png";